import React, { HTMLAttributes, useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { debounce } from 'lodash';
import useCustomer from '../../../../../../hooks/api/useCustomer';

export interface CustomerOption {
  label: string;
  value: string;
}

const newCustomerOption: CustomerOption = {
  label: '+ Créer un client',
  value: 'new',
};

interface Props extends HTMLAttributes<HTMLElement> {
  onChange: (event, option?: CustomerOption | null) => void;
  error?: string;
}

const CustomerSelect: React.FC<Props> = ({ className, error, onChange }) => {
  const { getAll } = useCustomer();
  const [customerQuery, setCustomerQuery] = useState('');
  const [customers, setCustomers] = useState<CustomerOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getAll(customerQuery, 1, 10)
      .then((collections) => {
        const customers = collections.items.map((item) => ({ value: item.id, label: item.name }));
        setCustomers(customers);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [customerQuery]);

  const handleChangeQuery = debounce((query: string) => {
    setCustomerQuery(query);
  }, 600);

  return (
    <Autocomplete
      className={className}
      loading={loading}
      options={[...customers, newCustomerOption]}
      getOptionLabel={(customer) => customer.label}
      filterOptions={(x) => x}
      includeInputInList
      onChange={onChange}
      loadingText='Chargement'
      noOptionsText='Aucun client trouvé ...'
      renderOption={(option: CustomerOption) => <>{option.value === 'new' ? <em>{option.label}</em> : option.label}</>}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Client associé'
          error={error !== undefined}
          helperText={error}
          onChange={(e) => handleChangeQuery(e.target.value)}
          fullWidth
        />
      )}
    />
  );
};

export default CustomerSelect;
